import { useMutation } from "@apollo/client/react";

import { ManagedUser, ManagedUserUpdateInput } from "types/generated";

import { UPDATE_MANAGED_USER } from "./gql";

type ManagedUserUpdateResponse = {
  managedUserUpdate: ManagedUser;
};

const useUpdateUser = (
  refetchQueries?: useMutation.Options<ManagedUserUpdateResponse>["refetchQueries"]
) => {
  const [updateManagedUser, { loading }] = useMutation<ManagedUserUpdateResponse>(
    UPDATE_MANAGED_USER,
    {
      refetchQueries,
    }
  );

  const onUpdate = (input: ManagedUserUpdateInput) => {
    return updateManagedUser({
      variables: {
        input,
      },
    });
  };

  return { onUpdate, loading };
};

export default useUpdateUser;
